import React from 'react';
import styled from 'styled-components';
import HeaderWrapper from './HeaderWrapper';
import HeaderContainer from './HeaderContainer';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HeaderMenu';
import { Link, NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import SocialIcons from '../SocialIcons';


// Иконки соцсетей справа от меню, показываются вместе с ним (на мобильных меню в бургере)
const HeaderSocialLinks = styled.div`
    display: none;

    img {
        display: block;
        margin-right: 15px;
        transition: .3s ease-in-out;
    }
    img:hover {
        transform: scale(1.20);
    }

    @media(min-width:1120px) {
        display: flex;
        align-items: center;
    }
`


const Header = () => {

    return (
        <HeaderContainer>
            <HeaderWrapper>
                <HeaderLogo />
                <HeaderMenu>
                    <ul>
                        <li><NavLink end to="/">Home</NavLink></li>
                        <li><NavLink to="/about/">About us</NavLink></li>
                        <li><NavLink to="/projects/">Projects</NavLink></li>
                        <li><NavLink to="/allnews/">News</NavLink></li>
                        <li><HashLink to="#ContactUs">Contact us</HashLink></li>
                    </ul>
                </HeaderMenu>
                <HeaderSocialLinks>
                    <SocialIcons />
                </HeaderSocialLinks>
            </HeaderWrapper>
        </HeaderContainer>
    );
}
 
export default Header;